import classnames from 'classnames';
import { type FunctionComponent } from 'react';

import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { StringABTests } from '@/productDiscovery/Listings/constants';

import styles from './ProductCardListingsSkeleton.module.scss';

export interface ProductCardListingsSkeletonProps {
  /**
   * Root element className
   */
  className?: string;
  b2b?: boolean;
  presentation?: 'technical' | 'inspirational';
  promoted?: boolean;
}

export const ProductCardListingsSkeleton: FunctionComponent<
  ProductCardListingsSkeletonProps
> = ({ className, b2b, presentation = 'technical', promoted }) => {
  const [technicalInfoEnabled] = useBooleanFlags([
    StringABTests.TECHNICAL_INFO_IN_PC,
  ]);

  const rootClassNames = classnames(
    styles.root,
    {
      [styles.b2b]: b2b,
      [styles.technical]: presentation === 'technical',
      [styles.inspirational]: presentation === 'inspirational',
      [styles.promoted]: promoted,
      [styles.withTechnicalInfo]: technicalInfoEnabled,
    },
    className,
  );

  return (
    <div className={rootClassNames}>
      <Skeleton className={styles.imageSkeleton} />
      <Skeleton className={styles.firstLineTitleSkeleton} />
      <Skeleton className={styles.secondLineTitleSkeleton} />
      {technicalInfoEnabled && (
        <Skeleton className={styles.thirdLineTitleSkeleton} />
      )}
      <Skeleton className={styles.priceSkeleton} />
    </div>
  );
};

ProductCardListingsSkeleton.displayName = 'ProductCardListingsSkeleton';
